import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_key_in_record, assert_true } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { TYPE__class_constructor } from '@shared/types/TYPE__class_constructor';
import { number_round, UTILS__number } from '@shared/utils/utils_number';
import { plainToInstance } from 'class-transformer';
import { FN_SERIALIZATION__is_primitive_type } from './_methods/FN_SERIALIZATION__is_primitive_type';
const ignored_types = ['TransportError'];

let { SERIALIZATION_CLASS_FIELD_INSTANCE, CLASS_MAPPING_REGISTERED_CLASSES } = CONSTANTS__shared;

export function FN_SERIALIZATION__data_deserialize(data: any): any {
  let out = data;

  let is_data_object = data != null && typeof data == 'object';
  let contains_class_field = is_data_object && SERIALIZATION_CLASS_FIELD_INSTANCE in data;
  let class_field_value = contains_class_field ? data[SERIALIZATION_CLASS_FIELD_INSTANCE] : '';

  if (contains_class_field && class_field_value == ENUM__dto_class_name.MAP_SERIALIZABLE_ITEMS_HOLDER) {
    out = {};

    for (const key of Object.keys(data)) {
      out[key] = FN_SERIALIZATION__data_deserialize(data[key]);
    }
  } else if (data == 'NaN') {
    out = NaN;
  } else if (UTILS__number.is_safe(data)) {
    data = number_round(data, 2);
  } else if (data instanceof Uint8Array || data instanceof Uint16Array || data instanceof Uint32Array || data instanceof ArrayBuffer || data instanceof Blob) {
    out = data;
  } else if (Array.isArray(data)) {
    out = data.map(item => FN_SERIALIZATION__data_deserialize(item));
  } else if (ignored_types.includes(data?.constructor?.name)) {
    //do nothing
  } else if (is_data_object && Object.keys(data).length === 0) {
    //empty object
    out = data;
  } else if (is_data_object) {
    assert_true(contains_class_field, { assert_type: ENUM__error_type.SERIALIZATION_CLASSNAME_IS_EMPTY });

    let class_name = data[SERIALIZATION_CLASS_FIELD_INSTANCE];

    if (class_name == ENUM__dto_class_name.ABSTRACT) debugger;

    let class_object = assert_key_in_record<string, TYPE__class_constructor>(CLASS_MAPPING_REGISTERED_CLASSES, class_name, {
      assert_type: ENUM__error_type.SERIALIZATION_CLASS_NOT_FOUND,
    });

    out = plainToInstance(class_object, data);

    for (const key of Object.keys(data)) {
      out[key] = FN_SERIALIZATION__data_deserialize(data[key]);
    }
  } else if (FN_SERIALIZATION__is_primitive_type(data)) {
    // do nothing
  } else {
    debugger;
  }

  return out;
}
